import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { DataTable, Card } from '../UI';

const columns = [
  { name: 'Name', cell: (row) => <Link to={`/admins/${row.id}`}>{row.name}</Link> },
  { name: 'Email', selector: 'email' },
  { name: 'Role', selector: 'role' },
  { name: 'MFA', selector: (row) => (row.mfa_enabled ? '✓' : '—') },
];

export default function AdminsListing() {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData(Endpoints.LIST_ADMINS)
      .then((res) => res.json())
      .then((res) => {
        setAdmins(res.admins || []);
        setLoading(false);
      });
  }, []);

  return (
    <PageLayout title="Admins">
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={admins}
          progressPending={loading}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
